import {trackEvent} from '../../modules/ga-event.js';

/** Keeps one displayed draft until submission; retries carry the frozen payload. */
export class OpenerNudgeObservation {
  constructor(apiClient) {
    this.apiClient = apiClient;
    this.current = null;
    this.acceptedIds = new Set();
  }

  shown(threadId, text, nudge) {
    const expires = Number(nudge.observation_expires_at) * 1000;
    this.current = /^[a-f0-9]{32}$/.test(nudge.observation_id || '') && expires > Date.now() ? {
      id: nudge.observation_id,
      threadId: String(threadId),
      text,
      kind: nudge.kind === 'compliment' ? 'compliment' : 'greeting',
      action: 'edit',
      expires,
    } : null;
    this.event('shown');
  }

  event(event) {
    const current = this.current;
    if (!current || Date.now() > current.expires) {
      return;
    }
    if (event !== 'shown') {
      current.action = event;
    }
    try {
      Promise.resolve(this.apiClient.request('/opener-nudge-observation', {
        method: 'POST',
        body: new URLSearchParams({observation_id: current.id, event}),
      })).catch(() => {});
    } catch { /* Telemetry cannot affect the composer. */ }
    this.ga(`opener_nudge_${event}`, {nudge_kind: current.kind});
  }

  take(threadId, text, retain = false) {
    const current = this.current;
    if (!retain) {
      this.current = null;
    }
    if (!current || current.threadId !== String(threadId) || Date.now() > current.expires || text === '') {
      return null;
    }
    return JSON.stringify({id: current.id, action: current.action, changed: text !== current.text, kind: current.kind});
  }

  accepted(payload) {
    if (!payload) {
      return;
    }
    try {
      const data = JSON.parse(payload);
      if (this.current?.id === data.id) {
        this.current = null;
      }
      if (this.acceptedIds.has(data.id)) {
        return;
      }
      this.acceptedIds.add(data.id);
      if (this.acceptedIds.size > 100) {
        this.acceptedIds.delete(this.acceptedIds.values().next().value);
      }
      this.ga('opener_nudge_sent', {nudge_kind: data.kind, nudge_action: data.action, draft_changed: data.changed});
    } catch { /* A malformed optional payload cannot change a successful send. */ }
  }

  ga(event, values) {
    try {
      trackEvent(event, values);
    } catch { /* GA4 is a secondary mirror. */ }
  }
}
